import Vue from 'vue';
import RechargeRecord from './recharge-record.vue';

export default {
  showRechargeRecord({
    context = null,
    thisFlowRequest,
    myRoleInfo,
    payBusiness,
    sellChannel,
    spInfo,
    flowId,
    pageSize,
    option,
  } = {}) {
    return new Promise(() => {
      const RechargeRecordCreator = Vue.extend(RechargeRecord);

      const rechargeRecord = new RechargeRecordCreator({
        el: document.createElement('div'),
        created() {
          console.log('11111111');
          console.log('payBusiness', payBusiness);
          console.log('sellChannel', sellChannel);
          console.log('flowId', flowId);
          console.log('pageSize', pageSize);
          console.log('option', option);
          console.log('myRoleInfo', myRoleInfo);
          this.thisFlowRequest = thisFlowRequest;
          this.myRoleInfo = myRoleInfo; // 支付流水归属
          this.payBusiness = payBusiness; // 支付流水归属
          this.sellChannel = sellChannel; // 销售渠道
          this.flowId = flowId; // 查询条件ID
          this.spInfo = spInfo || ''; // midas券信息

          this.pageSize = pageSize;
          this.option = option;

          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(rechargeRecord.$el);
    });
  },
};

// {
//   "ret": 0,
//   "msg": "",
//   "detail": "",
//   "data": {
//     "ret": 0,
//     "total": 10,
//     "data": [{
//         "CreateAt": 1659488795,
//         "GoodsName": "40元悦享卡优惠券x3",
//         "Price": 10800,
//         "Quantity": 1,
//         "RealPay": 10800,
//         "TotalPrice": 10800
//       },
//       {
//         "CreateAt": 1659425512,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 108800,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 108800
//       },
//       {
//         "CreateAt": 1659425095,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 108800,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 108800
//       },
//       {
//         "CreateAt": 1659424195,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 108800,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 108800
//       },
//       {
//         "CreateAt": 1659338780,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 108800,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 108800
//       },
//       {
//         "CreateAt": 1659325317,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 108800,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 108800
//       },
//       {
//         "CreateAt": 1659323941,
//         "GoodsName": "387.9元优惠券x3张",
//         "Price": 6000,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 6000
//       },
//       {
//         "CreateAt": 1658892286,
//         "GoodsName": "Q飞商城推广一元购",
//         "Price": 100,
//         "Quantity": 1,
//         "RealPay": 0,
//         "TotalPrice": 100
//       },
//       {
//         "CreateAt": 1658892216,
//         "GoodsName": "Q飞商城推广一元购",
//         "Price": 100,
//         "Quantity": 1,
//         "RealPay": 100,
//         "TotalPrice": 100
//       },
//       {
//         "CreateAt": 1658889996,
//         "GoodsName": "Q飞商城推广一元购",
//         "Price": 100,
//         "Quantity": 1,
//         "RealPay": 100,
//         "TotalPrice": 100
//       }
//     ]
//   }
// }
